import React, {useState, useEffect} from 'react';
import SpotCard from '../components/SpotCard';
import {toast} from 'react-toastify';
import { useSpotContext } from '../context/SpotProvider';
import { useAuth } from '../context/AuthProvider';
import { SpotMenu } from '../components/SpotMenu';
import { useLocation } from 'react-router-dom';
// import GetTheme from '../MuiTheme';

const SPOT_STATUS_LOCKED = process.env.REACT_APP_SPOT_STATUS_LOCKED;
const SPOT_STATUS_FREE = process.env.REACT_APP_SPOT_STATUS_FREE;
const SPOT_STATUS_PREORDERED = process.env.REACT_APP_SPOT_STATUS_PREORDERED;
const SPOT_STATUS_ORDERED = process.env.REACT_APP_SPOT_STATUS_ORDERED;
const SPOT_STATUS_INVOICED = process.env.REACT_APP_SPOT_STATUS_INVOICED;
const SPOT_STATUS_PAYED = process.env.REACT_APP_SPOT_STATUS_PAYED;

function ShowSpotsList () {
  //const navigate = useNavigate();
  const [showSpots, setShowSpots] = useState('Kaikki');  
  const [sizeFilter, setSizeFilter] = useState([]);
  const [warnShown, setWarnShown] = useState(false);
  const [loaded, setLoaded] = useState(false);  
  const [filteredSpots, setFilteredSpots] = useState([]);
  const {spots, getOrders} = useSpotContext();
  const {auth} = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!auth?.user) {
      return;
    }

    if (location.state?.initialShowSpots === 'Omat') {
      setShowSpots('Omat');
    }
  }, [auth?.user, location.state]);


  

  useEffect(() => {
      if(!auth?.user && !warnShown) {        
        toast.warn("Rekisteröidy tai kirjaudu mikäli haluat tehdä varauksen!", {id: 1});    
        setWarnShown(true);
      }
  },[]);

  const spotsLoaded = () => {
    setLoaded(true);
}

  useEffect(() => {

    console.log("Get filtered spots");

    let filtered = spots.filter((spot) => {
      switch (showSpots) {
        case 'Kaikki':
          return true;
        case 'Vapaa':
          return spot.status === SPOT_STATUS_FREE || spot.status === SPOT_STATUS_LOCKED;
        case 'Ennakko':
          return spot.status === SPOT_STATUS_PREORDERED;
        case 'Vahvistettu':
          return spot.status === SPOT_STATUS_PAYED;
        case 'Varattu':
          return spot.status === SPOT_STATUS_ORDERED || spot.status === SPOT_STATUS_INVOICED || spot.status === 'Maksu paikalla';
        case 'Valitut':
          return spot.userID === auth?.user?.userID && (spot.status === SPOT_STATUS_LOCKED || spot.status === SPOT_STATUS_PREORDERED);
        case 'Omat':
          return spot.userID === auth?.user?.userID;
        default:
          return true;
      }
    });

    filtered = sizeFilter.length
      ? filtered.filter((spot) => sizeFilter.some((item) => item.size.includes(spot.size)))
      : filtered;

    setFilteredSpots(filtered);

  },[showSpots, sizeFilter, spots, auth]);

  useEffect(() => {
    //let isMounted = true;
    
    const refreshSpots = (showError = false) => {
      if (typeof document !== 'undefined' && document.visibilityState !== 'visible') {
        return;
      }

      getOrders(spotsLoaded, { showError });
    };

    getOrders(spotsLoaded);

    const interval = setInterval(() => {
      refreshSpots(false);
    }, 60000); // 60 seconds

    const handleVisibilityChange = () => refreshSpots(false);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    }; // Clenup on unmount

    //return () => {
    //    isMounted = false;
    //    controller.abort();
    //}
  },[]);


  return (
    <div>

    { loaded ?  (
      <>
        <SpotMenu showSpots={showSpots} setShowSpots={setShowSpots} sizeFilter={sizeFilter} setSizeFilter={setSizeFilter} />
      
        { spots?.length ? (     
           <>            
            <div className="mt-16 grid grid-cols-1 lg:grid-cols-3 sm:grid-cols-2 gap-2 sm:w-full">
            { 
                filteredSpots.map((spot, i) => {                
                    return <SpotCard spot={spot} id={i} key={spot.id} panel={i}/>                
                })
            } 
            
            </div>                        
            </>) : ( <div className='center-text'> <p>Loading</p> </div> ) }
        
      </>) : ( "Loading" ) }

        
        
         
            
            {/*
            <Stack direction="row" alignItems="center" justifyContent="center" sx={{ p: 2 }} spacing={2}>
                <Button type="submit" variant="contained" color="primary">Lähetä</Button>
                <Button variant="contained"  color="secondary" href="/">Takaisin</Button>
            </Stack>        
            */}
    </div>
  );
};

export default ShowSpotsList;